import {
  ALL_TEMPLATES_FILTER,
  FAVORITE_TEMPLATES_FILTER,
  MessageCardData,
  MessageTemplate,
} from './MessageTemplatesModal';

const badgeColors = [
  'var(--mint-1)',
  'var(--blue-2)',
  'var(--orange-1)',
  'var(--purple-2)',
  'var(--pink-1)',
  'var(--green-1)',
];

export const filterTemplates = (
  selectedFilter: string,
  allMessageTemplates: MessageCardData[],
  randomizedMessageTemplates: MessageCardData[],
): MessageCardData[] => {
  switch (selectedFilter) {
    case ALL_TEMPLATES_FILTER:
      return randomizedMessageTemplates;
    case FAVORITE_TEMPLATES_FILTER:
      return allMessageTemplates.filter((t) => t.favorite);
    default:
      return randomizedMessageTemplates.filter(
        (t) => t.category === selectedFilter,
      );
  }
};

const getOrCreateCategoryColor = (
  category: string,
  colorMap: { [category: string]: string },
): string => {
  if (!colorMap[category]) {
    const colorIndex = Object.keys(colorMap).length % badgeColors.length;
    // eslint-disable-next-line no-param-reassign
    colorMap[category] = badgeColors[colorIndex];
  }

  return colorMap[category];
};

export const addColorMappings = (
  data: MessageTemplate[],
): MessageCardData[] => {
  const colorMap = {};

  return data.map((template) => ({
    ...template,
    color: getOrCreateCategoryColor(template.category, colorMap),
  }));
};

export const mapPreviousTemplates = (
  prevTemplates: MessageCardData[],
  curTemplates: MessageCardData[],
): MessageCardData[] => {
  const prevTemplateIds = prevTemplates.map((template) => template.id);
  const updatedTemplates = curTemplates.filter((template) =>
    prevTemplateIds.includes(template.id),
  );

  // randomized order from previous data is retained
  return prevTemplateIds.map(
    (id) => updatedTemplates.filter((template) => template.id === id)[0],
  );
};
